import { name } from "msal/lib-commonjs/packageMetadata"
import symptoms from "../../pages/find-care-options/symptoms"

/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1      Usha       24/01/2020      1973: Related Symptoms Implementation
*********************************************************************************/
export function presentRelatedSymptomAdd({ symptom, state, actions, setState, selectedSymptoms }) {
    const { triageRequest } = state
    const symTitle = state.isTravelAid2 ? symptom.emergencyQuestionId : symptom.id
    const { presentRelatedSymptomsMap } = triageRequest
    actions.setSortedPresentRelatedSymptoms({
        presentRelatedSymptomsMap:
        {
            ...(presentRelatedSymptomsMap || []),
            [symTitle]: symptom,
        }
    }
    )
}
export function presentRelatedSymptomRemoved({ symptom, state, actions, setState }) {
    const { triageRequest } = state
    const { presentRelatedSymptomsMap } = triageRequest
    const symId = state.isTravelAid2 ? symptom.emergencyQuestionId : symptom.id
    delete presentRelatedSymptomsMap[symId]
    actions.setSortedPresentRelatedSymptoms({
        presentRelatedSymptomsMap
    })
}
export function setSortedPresentRelatedSymptoms({ presentRelatedSymptomsMap, state, setState, actions }) {
    const currentRelatedSymptomTitles = state.isTravelAid2 ? (presentRelatedSymptomsMap.emergencyQuestionId) : (Object.keys(presentRelatedSymptomsMap).map(k => presentRelatedSymptomsMap[k].name))
    const currentRelatedSymptomsSortedKeys = Object.keys(presentRelatedSymptomsMap).sort((a, b) => {
        // Sort by title
        const x = state.isTravelAid2 ? presentRelatedSymptomsMap[a].emergencyQuestionId : presentRelatedSymptomsMap[a].name
        const y = state.isTravelAid2 ? presentRelatedSymptomsMap[b].emergencyQuestionId : presentRelatedSymptomsMap[b].name
        return x < y ? -1 : x > y ? 1 : 0
    })
    actions.setTriageRequest({
        presentRelatedSymptomsMap: presentRelatedSymptomsMap
    })
    setState({
        currentRelatedSymptomsSortedKeys,
        currentRelatedSymptomTitles
    })

}
export function absentRelatedSymptomAdd({ symptom, state, actions }) {
    const { triageRequest } = state
    const { absentRelatedSymptomsMap } = triageRequest
    const symTitle = state.isTravelAid2 ? symptom.emergencyQuestionId : symptom.id

    // const symId = state.isTravelAid2 ? symptom.emergencyQuestionId : symptom.symptom.id
    actions.setSortedAbsentRelatedSymptoms({
        absentRelatedSymptomsMap: {
            ...absentRelatedSymptomsMap,
            [symTitle]: symptom
        }
    })

}
export function absentRelatedSymptomRemove({ symptom, state, actions }) {
    const { triageRequest } = state
    const { absentRelatedSymptomsMap } = triageRequest
    const symId = state.isTravelAid2 ? symptom.emergencyQuestionId : symptom.id
    delete absentRelatedSymptomsMap[symId]
    actions.setSortedAbsentRelatedSymptoms({
        absentRelatedSymptomsMap
    })
}
export function setSortedAbsentRelatedSymptoms({ absentRelatedSymptomsMap, setState, actions }) {
    const currentRelatedNoSymptomTitles = Object.keys(absentRelatedSymptomsMap).map(k => absentRelatedSymptomsMap[k].name)
    const currentNoRelatedSymptomsSortedKeys = Object.keys(absentRelatedSymptomsMap).sort((a, b) => {
        // Sort by title
        const x = absentRelatedSymptomsMap[a].name
        const y = absentRelatedSymptomsMap[b].name
        return x < y ? -1 : x > y ? 1 : 0
    })
    actions.setTriageRequest({
        absentRelatedSymptomsMap: absentRelatedSymptomsMap
    })
    setState({
        currentNoRelatedSymptomsSortedKeys,
        currentRelatedNoSymptomTitles
    })

}